/* Carro lateral: recomendaciones que tienen sentido con lo que hay en el carro.
   - Solo combinaciones lógicas (mapa de categorías que se llevan juntas), con lo más vendido de cada una.
   - Nunca productos en preventa.
   - Nunca el mismo tipo de mueble que ya está en el carro (ni dos del mismo tipo entre las recomendaciones).
   - Al final, un detalle económico (marcos de fotos) para completar la compra. */
(function () {
  if (window.__cartRecs) return;
  window.__cartRecs = true;

  var MAIN = 4;
  var AFFINITY = {
    'centro': ['alfombras', 'mesa-auxiliar', 'rack-tv'],
    'lateral': ['mesas-de-centro', 'alfombras', 'sillas-sitiales'],
    'zapatero': ['percheros', 'muebles-arrimo', 'banquetas-baules'],
    'perchero': ['zapateros', 'muebles-arrimo', 'banquetas-baules'],
    'arrimo': ['espejos', 'percheros', 'zapateros'],
    'banqueta': ['zapateros', 'percheros', 'muebles-arrimo'],
    'estante': ['escritorios', 'organizadores', 'decoracion'],
    'escritorio': ['estanteria-para-libros', 'organizadores', 'sillas-sitiales'],
    'rack': ['mesas-de-centro', 'alfombras', 'estanteria-para-libros'],
    'organizador': ['estanteria-para-libros', 'escritorios', 'repisas'],
    'tocador': ['espejos', 'banquetas-baules', 'comodas'],
    'espejo': ['comodas', 'muebles-arrimo', 'percheros'],
    'marco': ['alfombras', 'mesa-auxiliar', 'espejos'],
    'alfombra': ['mesas-de-centro', 'mesa-auxiliar', 'sillas-sitiales'],
    'silla': ['mesa-auxiliar', 'mesas-de-centro', 'alfombras'],
    'buffet': ['sillas-sitiales', 'espejos', 'alfombras'],
    'carro': ['taburetes', 'organizadores', 'alfombras'],
    'comoda': ['espejos', 'mesa-auxiliar', 'alfombras'],
    'comedor': ['sillas-sitiales', 'buffets', 'alfombras']
  };
  var DEFAULT = ['alfombras', 'espejos', 'decoracion'];
  var busy = false;

  function family(text) {
    var t = String(text || '').toLowerCase();
    function has() { for (var i = 0; i < arguments.length; i++) if (t.indexOf(arguments[i]) > -1) return true; return false; }
    if (has('mesa de centro', 'mesas de centro', 'mesa centro', 'mesas centro', 'nido')) return 'centro';
    if (has('mesa lateral', 'mesas laterales', 'mesa auxiliar', 'mesas auxiliares', 'velador')) return 'lateral';
    if (has('rack')) return 'rack';
    if (has('zapatero')) return 'zapatero';
    if (has('perchero')) return 'perchero';
    if (has('arrimo', 'recibidor', 'consola')) return 'arrimo';
    if (has('escritorio')) return 'escritorio';
    if (has('tocador')) return 'tocador';
    if (has('estanter', 'librero', 'repisa', 'esquinero')) return 'estante';
    if (has('organizador', 'canasto', 'cajas')) return 'organizador';
    if (has('espejo')) return 'espejo';
    if (has('marco de foto', 'marcos de foto', 'marcos', 'cuadro')) return 'marco';
    if (has('banqueta', 'baul', 'baúl', 'otomana')) return 'banqueta';
    if (has('alfombra')) return 'alfombra';
    if (has('silla', 'sitial', 'taburete', 'poltrona')) return 'silla';
    if (has('buffet', 'aparador')) return 'buffet';
    if (has('carro', 'carrito', 'isla de cocina')) return 'carro';
    if (has('comoda', 'cómoda')) return 'comoda';
    if (has('mesa de comedor', 'mesa comedor')) return 'comedor';
    return '';
  }
  function isPreorder(p) { return (p.tags || []).some(function (t) { return /preventa/i.test(t); }); }
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function norm(p) {
    if (isPreorder(p)) return null;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    return { id: p.id, handle: p.handle, title: p.title, url: '/products/' + p.handle, fam: family(p.title + ' ' + (p.product_type || '')),
      image: (p.images && p.images[0] && p.images[0].src) || '',
      price: Math.round(parseFloat(v.price) * 100),
      compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
      variant: v.id };
  }
  function card(p) {
    var img = p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
    return '<div class="cart-recommendation-item" data-product-id="' + p.id + '"><a href="' + p.url + '" class="cart-recommendation-item__image">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
      '<div class="cart-recommendation-item__info"><a href="' + p.url + '" class="cart-recommendation-item__title-link"><p class="cart-recommendation-item__title">' + esc(p.title) + '</p></a>' +
      '<p class="cart-recommendation-item__price">' + (p.compare ? '<span class="price--sale">' + money(p.price) + '</span><s>' + money(p.compare) + '</s>' : money(p.price)) + '</p>' +
      '<button type="button" class="cart-recommendation-item__add" data-variant-id="' + p.variant + '">Agregar</button></div></div>';
  }
  function hide(el) { var w = el && el.closest('[data-recs-wrap]'); if (w) w.style.display = 'none'; }

  /* no en el carro, sin repetir, y sin el mismo tipo de mueble que ya lleva o que ya se recomendó */
  function pick(list, have, cartFam, out, seen, seenFam) {
    for (var k = 0; k < list.length; k++) {
      var p = list[k];
      if (have.indexOf(',' + p.handle + ',') > -1 || seen[p.handle]) continue;
      if (p.fam && (cartFam[p.fam] || seenFam[p.fam])) continue;
      seen[p.handle] = 1; if (p.fam) seenFam[p.fam] = 1; out.push(p); return true;
    }
    return false;
  }

  function build(cart, have, cartFam) {
    var items = cart.items.slice().sort(function (a, b) { return b.final_price - a.final_price; });
    var perItem = items.map(function (it) { return (AFFINITY[family(it.product_title + ' ' + it.product_type)] || DEFAULT).slice(); });
    var handles = { 'decoracion': 1 };
    perItem.forEach(function (l) { l.forEach(function (h) { handles[h] = 1; }); });
    var names = Object.keys(handles).slice(0, 9);
    return Promise.all(names.map(function (h) {
      return fetch('/collections/' + h + '/products.json?limit=60&sort_by=best-selling').then(function (r) { return r.json(); }).then(function (d) { return { h: h, list: (d.products || []).map(norm).filter(Boolean) }; }).catch(function () { return { h: h, list: [] }; });
    })).then(function (res) {
      var by = {}; res.forEach(function (x) { by[x.h] = x.list; });
      var out = [], seen = {}, seenFam = {};
      for (var round = 0; round < 3 && out.length < MAIN; round++) {
        for (var i = 0; i < perItem.length && out.length < MAIN; i++) {
          var order = perItem[i];
          pick(by[order[round % order.length]] || [], have, cartFam, out, seen, seenFam);
        }
      }
      /* detalle económico para completar: el marco de fotos más barato */
      if (!cartFam.marco && !seenFam.marco) {
        var cheap = (by.decoracion || []).filter(function (p) { return p.fam === 'marco' && have.indexOf(',' + p.handle + ',') === -1 && !seen[p.handle]; })
          .sort(function (a, b) { return a.price - b.price; })[0];
        if (cheap) out.push(cheap);
      }
      return out;
    });
  }

  function fill() {
    var box = document.querySelector('[data-recs-fallback]');
    if (!box || box.children.length || box.dataset.loading || busy) return;
    var have = box.dataset.cartHandles || ',';
    busy = true; box.dataset.loading = '1';
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var cartFam = {};
      cart.items.forEach(function (it) { var f = family(it.product_title + ' ' + it.product_type); if (f) cartFam[f] = 1; });
      return build(cart, have, cartFam);
    }).then(function (list) {
      var el = document.querySelector('[data-recs-fallback]');
      if (!el) return;
      if (list.length) el.innerHTML = list.map(card).join(''); else hide(el);
    }).catch(function () { hide(box); }).then(function () { busy = false; });
  }

  document.addEventListener('DOMContentLoaded', fill);
  if (document.readyState !== 'loading') fill();
  new MutationObserver(function () { fill(); }).observe(document.documentElement, { childList: true, subtree: true });
})();